'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.useTransformation = void 0;

var input_1 = require('../utils/input');

var function_1 = require('../utils/function');

var useTransformation = function useTransformation(_a) {
  var _b = _a.transformationRule,
    transformationRule = _b === void 0 ? input_1.defaultTrasformationRule : _b,
    _c = _a.onChange,
    onChange = _c === void 0 ? function_1.noop : _c,
    _d = _a.setValue,
    setValue = _d === void 0 ? function_1.noop : _d;

  var transformOnChange = function transformOnChange(event) {
    var transofmedValue = transformationRule.transform(event.target.value);
    onChange(event);
    setValue(transofmedValue);
  };

  var transformOnBlur = function transformOnBlur(value) {
    if (transformationRule.onBlurTransform && value) {
      setValue(transformationRule.onBlurTransform(value));
    }
  };

  return {
    transformOnChange: transformOnChange,
    transformOnBlur: transformOnBlur,
  };
};

exports.useTransformation = useTransformation;
